import React from "react";

export function ContactFind(props) {
    return (
        <div className="contact-find" id="contact-find">
            <h2 className="h1">{props.data.title}</h2>

            <div className="contact-find__offices">
                {
                    props.data.offices.map((office, i) => (

                        <div key={i} className="contact-find__office">
                            <h3>{office.title}</h3>
                            <div className="contact-find__office-items">
                                {
                                    office.item.map((item, i) => (

                                        <a key={i} href={item.href} target="_blank">
                                            <div className="icon">
                                                <i className={`agi ${item.iconId}`}></i>
                                            </div>
                                            {item.label}
                                        </a>

                                    ))
                                }
                            </div>
                        </div>

                    ))
                }
            </div>

        </div>
    );
}
